/**
 * Finished GathrXR Studio props anyone building in VR can place (the VR
 * library's "Gallery"). Studio itself is admin-only for now, so this is how
 * visitors and judges get to build with AI-made pieces. Bounds are the
 * model's own (metres), used to rest it on the floor where it's placed.
 */
export interface GalleryModel { id: string; title: string; url: string; thumb: string; minY: number; height: number }

export const STUDIO_GALLERY: GalleryModel[] = [
  {
    id: '1ff3fd18-2cbd-477b-a0b4-627952c89887', title: 'Lounge Chair',
    url: 'https://assets.gathrxr.com/studio/1ff3fd18-2cbd-477b-a0b4-627952c89887/result.glb',
    thumb: 'https://assets.gathrxr.com/studio/1ff3fd18-2cbd-477b-a0b4-627952c89887/preview-9.jpg', minY: 0, height: .83,
  },
  {
    id: 'b0ffdc1c-9989-4f32-9e29-8f4a0b778394', title: 'Brass Floor Lamp',
    url: 'https://assets.gathrxr.com/studio/b0ffdc1c-9989-4f32-9e29-8f4a0b778394/result.glb',
    thumb: 'https://assets.gathrxr.com/studio/b0ffdc1c-9989-4f32-9e29-8f4a0b778394/preview-1.jpg', minY: 0, height: 1.66,
  },
  {
    id: '7bcab8e1-426f-4ce1-a2f8-9ef7448a7dce', title: 'Terracotta Succulent',
    url: 'https://assets.gathrxr.com/studio/7bcab8e1-426f-4ce1-a2f8-9ef7448a7dce/result.glb',
    thumb: 'https://assets.gathrxr.com/studio/7bcab8e1-426f-4ce1-a2f8-9ef7448a7dce/preview-2.jpg', minY: 0, height: .22,
  },
];
